import { render } from "./RegionMap.vue?vue&type=template&id=4564c661"
import script from "./RegionMap.vue?vue&type=script&lang=js"
export * from "./RegionMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__